import type { PlainRoute } from 'react-router';

import { DependencySource } from '../../../../../shared/vendoredDependencies';
import { useRouter } from '../../../../contexts/RouterContext';

const DEPENDENCY_ROUTE_SOURCE = {
  dependencies: DependencySource.Managed,
  vendored: DependencySource.Vendored,
} as const;

/**
 * Helper to determine in which "mode" to display dependency-related views
 * (such as the dependency drawer), based on the currently selected route
 * context.
 * @param routes the current route path
 */
export function getDependencyModeFromRoute(routes: PlainRoute[]): DependencySource | undefined {
  const lastPath = routes.at(-1)?.path;
  return DEPENDENCY_ROUTE_SOURCE[lastPath as keyof typeof DEPENDENCY_ROUTE_SOURCE];
}

/**
 * Helper hook to resolve the effective dependency mode of the component context
 * derived statically from the route path.
 * @returns the effective dependency source mode; undefined if it cannot be determined
 */
const useDependencyMode = (): DependencySource | undefined => {
  const router = useRouter();

  return getDependencyModeFromRoute(router.routes);
};

export default useDependencyMode;
